module.exports = __webpack_public_path__ + "img/CROSS_SELL_REQUEST.png";